import { ITextLayout } from 'types'
import { LayoutHelpers } from '../../../desktopTypes'
import { addLayoutTag } from '../../../utils/helpers'
import { parsePadding, useParseText } from '../../../utils/layoutUtils'
import { SMarkdown, SViewProps } from '../../scaled'
import EmptyLayout from '../EmptyLayout'

export default function TextLayout({
  align,
  justify,
  scroll,
  size,
  style,
  title,
  text,
  weight,
}: Omit<ITextLayout, 'type'> & LayoutHelpers) {
  const parseText = useParseText()
  const justifyContent = parseJustify(justify)
  const padding = parsePadding({ style, title })

  const parsed = parseText(text)
  if (!parsed) return <EmptyLayout type="text" />

  return (
    <SMarkdown
      noScroll={!scroll}
      value={parsed}
      bodySize={size}
      baseWeight={weight}
      containerProps={{
        ...addLayoutTag('text'),
        ...padding,
        textAlign: align,
        grow: 1,
        alignItems: parseAlign(align),
        justifyContent,
      }}
    />
  )
}

function parseAlign(align?: ITextLayout['align']): SViewProps['alignItems'] {
  switch (align) {
    case 'left':
      return 'flex-start'
    case 'center':
      return 'center'
    case 'right':
      return 'flex-end'
    default:
      return 'stretch'
  }
}

function parseJustify(justify?: ITextLayout['justify']): SViewProps['justifyContent'] {
  switch (justify) {
    case 'center':
      return 'center'
    case 'bottom':
      return 'flex-end'
    default:
      return 'flex-start'
  }
}
